module.exports = __webpack_public_path__ + "img/leaveYourDislike.febf1a83.svg";